export default __webpack_public_path__ + "static/media/mysql-small.0e8797de.svg";